<template>
  <el-container style="height:100%;">
    <el-header>
      <Header title="鹿客竞练管理后台"></Header>
    </el-header>
    <el-container>
      <el-aside width="240px">
        <Sidebar />
      </el-aside>
      <el-main class="admin_main">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Header from "@/layouts/admin/Header";
import Sidebar from "@/layouts/admin/Sidebar";
export default {
  components: {
    Header,
    Sidebar,
  }
};
</script>

<style scpopd>
.el-container {
  overflow: auto;
}
.el-header {
  line-height: 61px;
  height: 61px !important;
  border-bottom: 1px solid rgb(121, 187, 255);
}
.admin_main {
  background-color: #eeeeee;
  /* height: 100%; */
}
</style>
